export default __webpack_public_path__ + "static/media/survey-instructions.67f57be6.png";